export const sectionContainer = {
  minW: {
    base: '100%',
    md: '628px',
    'lg+': '960px',
  },
}

export const mainVStack = {
  mt: { base: 16, md: '120px' },
  mb: 10,
  w: '100%',
  spacing: {
    base: 20,
    lg: 24,
  },
}

export const headingText = {
  fontSize: {
    base: '32px',
    md: '40px',
  },
  fontWeight: 'medium',
  textAlign: 'center',
}

export const logoStack = {
  direction: 'column',
  spacing: '16',
  alignItems: 'center',
  w: '100%',
}

export const logoLink = {
  h: {
    base: '320px',
    md: '640px',
  },

  w: 'auto',
  minW: { base: '500px', md: '1000px' },
  maxW: '100%',

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',

  _hover: {
    opacity: 0.8,
    transform: 'scale(1.05)',
  },
  transition: 'all 0.2s',
}

export const imageContainer = {
  h: '100%',
  w: '100%',
  position: 'relative',
}
